import React from 'react'
import {describeValidationOutcome} from './validationOutcome'

/** FE-081. Shared by both validation screens so the two cannot drift apart again. */
const ValidationOutcomeText: React.FC<{response: any}> = ({response}) => {
  const {ok, text} = describeValidationOutcome(response)
  return (
    <span
      className={`fs-7 d-flex text-center justify-content-center text-break ${
        ok ? 'approved-pvin-text' : 'failed-pvin-text'
      }`}
    >
      <strong>{text}</strong>
    </span>
  )
}

export default ValidationOutcomeText
